module.exports = __webpack_public_path__ + "static/media/013.06f160e2.jpg";